import React from 'react';

import type { TDispatch } from '~/src/features/center/BlockInfo';

import * as ST from './styled';

interface IProps {
    defaultText: string,
    type: string,
    textButton?: string,
    actionType: string,
    onClickHandler: (
        _setState: TDispatch,
        setActive: TDispatch,
        actionType: string,
    ) => void,
    setHideStatus: TDispatch,
    setActive: TDispatch,
}

const SlotButton: React.FC<IProps> = ({
    defaultText,
    type,
    textButton,
    onClickHandler,
    setHideStatus,
    setActive,
    actionType,
}) => {
    return (
        <ST.Button
            onClick={() => onClickHandler(setHideStatus, setActive, actionType)}
            data-test={'button'}
            type={type}
        >
            {textButton || defaultText}
        </ST.Button>
    );
};

export default SlotButton;
